import { render, staticRenderFns } from "./TabsA.vue?vue&type=template&id=7c48fadb&scoped=true&lang=pug&"
import script from "./TabsA.vue?vue&type=script&lang=js&"
export * from "./TabsA.vue?vue&type=script&lang=js&"
import style0 from "./TabsA.vue?vue&type=style&index=0&id=7c48fadb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c48fadb",
  null
  
)

export default component.exports